
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

import Constants from '@/constants/constants';

import FlatSelectorTextInput from '@/shared/components/flatSelectorTextInput/flatSelectorTextInput.view.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

import UtilsService from '@/core/services/utils.service';
import ClickOutside from '@/shared/mixins/clickOutside.mixin.ts';

interface MixinInterface extends ClickOutside, Vue {
}

export enum FlatSelectorTextPredefinedStyle {
  TableRow = 'flat-selector-text--table-row',
  Form = 'flat-selector-text--form',
}

export enum FlatSelectorTextBorderBottom {
  Primary = 'bdr-bt--primary',
  Secondary = 'bdr-bt--secondary',
}

export enum FlatSelectorTextWeight {
  Bold = 'flat-selector-text__value--bold',
  Normal = 'flat-selector-text__value--normal',
}

export enum FlatSelectorTextSize {
  Md = 'flat-selector-text--size-md',
  Sm = 'flat-selector-text--size-sm',
}

@Component({
  components: {
    FlatSelectorTextInput,
    Icon,
  },
})
export default class FlatSelectorText extends Mixins<MixinInterface>(ClickOutside, Vue) {
  @Prop({ default: false }) private multipleOptions!: boolean;
  @Prop() private options!: any[];
  @Prop() private optionInitial!: undefined;
  @Prop() private initialOptions!: any[];
  @Prop() private placeholder!: string;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private squad!: boolean;
  @Prop({ default: false }) private readOnly!: boolean;
  @Prop({ default: 16 }) private limit!: number;
  // tslint:disable-next-line:max-line-length
  @Prop({ default: FlatSelectorTextPredefinedStyle.TableRow })
  private predefinedStyle!: FlatSelectorTextPredefinedStyle;
  @Prop({ default: FlatSelectorTextBorderBottom.Primary })
  private borderBottom!: FlatSelectorTextBorderBottom;
  @Prop({ default: FlatSelectorTextWeight.Bold })
  private textWeight!: FlatSelectorTextWeight;
  @Prop() private textSize!: string;
  @Prop({ default: false }) private searchBackend!: boolean;
  @Prop({ default: true }) private scrollable!: boolean;
  @Prop({ default: false }) private clearable!: boolean;
  @Prop({ default: () => ({}) }) private optionFields!: any;
  @Prop({ default: '' }) private flatSelectorError!: string;

  private optionSelected: any = {};
  private showOptions: boolean = false;
  private showOptionsTimeout!: any;
  private filterString: string = '';
  private noVisibleOptions: boolean = false;
  private searchTimeout!: any;
  private resetComponent = false;
  private iconEnum = IconEnum;
  private searchEmitTime: number = Constants.searchEmitTime;
  private noResultsOption = {
    value: '-1',
    label: 'Sin resultados',
    disabled: true,
  };
  private defaultOption = {
    colorSelected: '',
    label: '',
    value: '0',
  };
  private focused = false;
  private selectedOptions: any = [];

  private created() {
    this.assignOptionSelected();
    this.handleClickOutside();
  }

  @Watch('optionInitial')
  private watchOptionInitial(newVal: any, oldVal: any) {
    if (newVal !== oldVal && !this.resetComponent) {
      this.assignOptionSelected();
    }
  }

  get inputValue() {
    return this.selectedOptions.length === 0
      ? '-'
      : this.selectedOptions
        .map((thisOption: any) => {
          return thisOption.label;
        })
        .join(' ');
  }

  private get showClearIcon() {
    return this.clearable && this.optionSelected.label;
  }

  private reset() {
    this.resetComponent = true;
    this.optionSelected = {
      colorSelected: '',
      label: '',
      value: '0',
    };
    this.$emit('input', this.defaultOption);
    this.$emit('change-option', this.defaultOption);
  }

  get visibleOptions() {
    let options: any[] = [];
    if (!this.searchBackend && UtilsService.objectIsEmpty(this.optionFields)) {
      options = this.filterOptionsFrontEnd();
    } else {
      options = UtilsService.parseToObject(this.optionFields, this.options);
      if (options.length === 0) {
        options.push(this.noResultsOption);
      }
    }
    if (!this.searchBackend && !UtilsService.objectIsEmpty(this.optionFields)) {
      options = this.filterOptionsFrontEnd(options);
    }
    return options;
  }

  get getBorderBottom() {
    let borderBottom = '';
    if (this.showOptions) {
      borderBottom = this.borderBottom;
    }
    return borderBottom;
  }

  get hasError() {
    return this.flatSelectorError !== '';
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private assignOptionSelected() {
    let finalOption = null;
    if (this.multipleOptions) {
      this.selectedOptions = UtilsService.parseToObject(
        this.optionFields,
        this.initialOptions,
      );
    } else {
      if (!this.searchBackend && UtilsService.objectIsEmpty(this.optionFields)) {
        finalOption = this.optionInitial;
      } else if (this.optionInitial !== undefined) {
        let initial = this.optionInitial;
        if (typeof this.optionInitial !== 'object') {
          initial = this.getOptionFromOptionList(initial);
        }
        const parsedOption = UtilsService.parseToObject(
          this.optionFields,
          initial as any,
        );
        if (parsedOption.length > 0) {
          finalOption = parsedOption[0];
        }
      }
      this.optionSelected = Object.assign(this.defaultOption, finalOption);
    }
  }

  private filterOptionsFrontEnd(options: any[] = []) {
    let selectOptions = this.options;
    if (options.length > 0) {
      selectOptions = options;
    }
    const filterString = this.filterString;
    const pattern = new RegExp(filterString, 'gi');
    const limit = this.limit;
    let optionsFilteredWithString: any[] = [];
    if (selectOptions) {
      selectOptions.forEach((option: any, index: number) => {
        const patternTest = option.label.match(pattern);
        if (filterString === '' || patternTest) {
          optionsFilteredWithString.push(option);
        }
      });
    }
    const optionsFilteredWithStringLength = optionsFilteredWithString.length;
    if (optionsFilteredWithStringLength > this.limit && !this.scrollable) {
      optionsFilteredWithString.length = this.limit;
    }
    if (optionsFilteredWithString.length === 0) {
      optionsFilteredWithString = [this.noResultsOption];
      this.noVisibleOptions = true;
    } else if (
      optionsFilteredWithString.length < optionsFilteredWithStringLength &&
      !this.scrollable
    ) {
      optionsFilteredWithString.push({
        value: '-1',
        label: `+ ${optionsFilteredWithStringLength -
          optionsFilteredWithString.length} resultados`,
        disabled: true,
      });
    }
    return optionsFilteredWithString;
  }

  private checkOptionSelected(option: any) {
    if (this.multipleOptions) {
      return (
        this.selectedOptions
          .map((thisOption: any) => {
            return thisOption.value;
          })
          .filter((value: string) => {
            return value === option.value;
          }).length > 0
      );
    } else {
      return option.value === this.optionSelected.value;
    }
  }

  private setShowOptionsFocus(value: boolean) {
    if (this.disabled || this.readOnly) {
      return false;
    }
    this.focused = value;
    setTimeout(() => {
      this.showOptions = this.focused;
      this.filterString = '';
    }, 500);
  }

  private setShowOptions(value: boolean) {
    if (this.disabled || this.readOnly) {
      return false;
    }
    if (!this.focused) {
      this.showOptionsTimeout = setTimeout(() => {
        this.showOptions = value;
        this.filterString = '';
      }, 500);
    }
  }

  private changeFilterString(filterString: string) {
    this.filterString = filterString;
    if (this.searchBackend) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$emit('search-option', {
          searchString: this.filterString,
          limit: this.limit,
        });
      }, this.searchEmitTime);
    }
  }

  private changeOptionSelected(option: any, index: number) {
    if (this.multipleOptions) {
      if (this.checkOptionSelected(option)) {
        const index = this.selectedOptions
          .map((thisOption: any) => {
            return thisOption.value;
          })
          .indexOf(option.value);
        this.selectedOptions.splice(index, 1);
      } else {
        this.selectedOptions.push(option);
      }
      this.selectedOptions = this.selectedOptions.sort(
        (option1: any, option2: any) => {
          return option1.label > option2.label;
        },
      );
      this.$emit('input', this.selectedOptions);
    } else {
      this.setShowOptions(false);
      this.showOptions = this.focused;
      this.optionSelected = option;
      this.noVisibleOptions = false;
      let finalOption = option;
      if (
        !UtilsService.objectIsEmpty(this.optionFields) &&
        this.optionInitial !== undefined &&
        typeof this.optionInitial !== 'object'
      ) {
        finalOption = option.value;
      } else if (!UtilsService.objectIsEmpty(this.optionFields)) {
        finalOption = this.getOptionFromOptionList(finalOption.label);
      }
      this.$emit('input', finalOption);
      this.$emit('change-option', finalOption);
      this.filterString = '';
    }
  }

  private getOptionFromOptionList(value: any) {
    let finalOption = value;
    const parsedOption = this.options.find(option=> {
      if (option.name && option.name == finalOption) {
        return option.name == finalOption
      } else {
        return option.id == finalOption
      }
    })
    if (parsedOption) {
      finalOption = parsedOption;
    }
    return finalOption;
  }

  private handleClickPrincipal(event: Event, option: any, index: number) {
    if(this.multipleOptions){
      event.stopPropagation();
    }
  }

  private handleClick(event: Event, option: any, index: number) {
    event.stopPropagation();
    this.setShowOptions(false);
    this.hideError();
    if (!option.disabled) {
      this.changeOptionSelected(option, index);
    }
  }

  private handleClickOutside() {
    if (this.multipleOptions) {
      this.clickOutside(() => {
        this.setShowOptionsFocus(false);
      }, 'dropdown');
    }
  }
}
